import React from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { PrimeIcons } from 'primereact/api';
import { FormField } from '../../FormField/FormField';
import { PhoneInput } from '../../PhoneInput/PhoneInput';
import { useNavigateScroll } from '../../../hooks/useNavigateScroll';
import { addQueryParamsToUrl } from '../../../utils/urlUtils';
import { Reservation } from '../../../types/reservation';
import { ReservationFormFieldProps } from '../types';

interface Props extends ReservationFormFieldProps {
  isModifying: boolean;
  showRequiredFields: boolean;
  showCreateUserButton: boolean;
  resource: Reservation | undefined;
}

/** Name, surnames and phone of a client that has no account. */
export const UnregisteredClientFields = ({
  form,
  setFormFields,
  validationErrors,
  isModifying,
  showRequiredFields,
  showCreateUserButton,
  resource,
}: Props) => {
  const navigate = useNavigateScroll();

  return (
    <div className='unregistered-client-container'>
      <FormField
        labelTitle='Nombre'
        elementId='unregistered-client-name'
        error={validationErrors?.unregisteredClientName}
        required={showRequiredFields}
      >
        {isModifying ? (
          <InputText
            id='unregistered-client-name'
            value={form?.unregisteredClientName ?? ''}
            onChange={(e) => setFormFields({ unregisteredClientName: e.target.value })}
            placeholder='Ej: Juan'
            className={classNames({ 'p-invalid': validationErrors?.unregisteredClientName })}
          />
        ) : (
          <p>{form?.unregisteredClientName}</p>
        )}
      </FormField>
      <FormField
        labelTitle='Apellidos'
        elementId='unregistered-client-surnames'
        error={validationErrors?.unregisteredClientSurnames}
        required={showRequiredFields}
      >
        {isModifying ? (
          <InputText
            id='unregistered-client-surnames'
            value={form?.unregisteredClientSurnames ?? ''}
            onChange={(e) => setFormFields({ unregisteredClientSurnames: e.target.value })}
            placeholder='Ej: García'
            className={classNames({ 'p-invalid': validationErrors?.unregisteredClientSurnames })}
          />
        ) : (
          <p>{form?.unregisteredClientSurnames}</p>
        )}
      </FormField>
      <FormField labelTitle='Teléfono' elementId='unregistered-client-phone' error={validationErrors?.unregisteredClientPhone}>
        {isModifying ? (
          <PhoneInput
            id='unregistered-client-phone'
            invalid={!!validationErrors?.unregisteredClientPhone}
            value={form?.unregisteredClientPhone}
            onChange={(value) => setFormFields({ unregisteredClientPhone: value })}
          />
        ) : (
          <p>{form?.unregisteredClientPhone}</p>
        )}
      </FormField>
      {showCreateUserButton && (
        <Button
          link
          icon={PrimeIcons.USER_PLUS}
          label='Crear usuario con estos datos'
          className='create-user-button'
          onClick={() => {
            navigate(
              addQueryParamsToUrl(`/users`, {
                name: form?.unregisteredClientName,
                surnames: form?.unregisteredClientSurnames,
                phone: form?.unregisteredClientPhone?.replace('+', '%2B'),
                branchId: form?.branch?.id,
                reservationId: resource?.id,
              }),
            );
          }}
        />
      )}
    </div>
  );
};
